import React from 'react'
import { IPortDetailsStep2 } from '@dataTypes/clinic.type'
import { InputField } from '@enamelai/design-system'
import { useAppSelector } from '@store/hooks'

interface EnterDetailsProps {
  data: IPortDetailsStep2
  handleChange: (field: string, value: string) => void
  validationErrors: { [key: string]: string }
}

const EnterDetails: React.FC<EnterDetailsProps> = ({
  data,
  handleChange,
  validationErrors,
}) => {
  const clinicData = useAppSelector((state) => state.clinic.selectedClinic)

  return (
    <div className="scp-pm-card">
      <div className="scp-pm-grid2">
        <InputField
          variant="text"
          fullWidth
          label="Authorizing person (LOA)"
          value={String(data.full_name || '')}
          onChange={(event) => handleChange('full_name', event.target.value)}
          error={!!validationErrors.full_name}
          helperText={validationErrors.full_name}
          clearable={false}
        />
        <InputField
          variant="email"
          fullWidth
          label="Email address"
          value={String(data.email_address || '')}
          onChange={(e) => handleChange('email_address', e.target.value)}
          error={!!validationErrors.email_address}
          helperText={validationErrors.email_address}
          clearable={false}
        />
      </div>
      <InputField
        variant="text"
        fullWidth
        label="Address"
        value={clinicData?.address || ''}
        disabled
        clearable={false}
      />
      <div className="scp-pm-grid2 scp-pm-grid-40">
        <InputField
          variant="text"
          fullWidth
          label="City"
          value={clinicData?.city || ''}
          disabled
          clearable={false}
        />
        <InputField
          variant="text"
          fullWidth
          label="State"
          value={clinicData?.state || ''}
          disabled
          clearable={false}
        />
        <InputField
          variant="text"
          fullWidth
          label="Zip"
          value={clinicData?.zip || ''}
          disabled
          clearable={false}
        />
      </div>
      <span className="scp-pm-blue-label">
        Current carrier account (optional)
      </span>
      <div className="scp-pm-grid2">
        <InputField
          variant="text"
          fullWidth
          label="Account number"
          value={data.wireless_account_number}
          onChange={(e) =>
            handleChange('wireless_account_number', e.target.value)
          }
          error={!!validationErrors.wireless_account_number}
          helperText={validationErrors.wireless_account_number}
          clearable={false}
        />
        <InputField
          variant="text"
          fullWidth
          label="Pin or SSN"
          className="scp-pm-short-field"
          value={data.pin_or_ssn}
          onChange={(e) => handleChange('pin_or_ssn', e.target.value)}
          error={!!validationErrors.pin_or_ssn}
          helperText={validationErrors.pin_or_ssn}
          clearable={false}
        />
      </div>
    </div>
  )
}

export default EnterDetails
